import { navigatorLanguageToLocale } from '../const/navigator-languages';

export function getActualLan(): string {
  const navigatorLanguage = navigatorLanguageToLocale(window.navigator.language);
  const getStorage = JSON.parse(localStorage['GetStorage'] ?? '{}');
  const langPrefix = getStorage?.['lang'] ?? localStorage.getItem('lan') ?? navigatorLanguage;
  return langPrefix.replace('_', '-');
}
